import React from 'react';
interface ColorPickerProps {
  label: string;
  value: string;
  onChange: (val: string) => void;
  allowTransparent?: boolean;
}
export function ColorPicker({
  label,
  value,
  onChange,
  allowTransparent
}: ColorPickerProps) {
  return <div className="flex flex-col gap-1.5" data-id="element-25">
      <label className="text-xs font-medium text-slate-700" data-id="element-26">{label}</label>
      <div className="flex items-center gap-2" data-id="element-27">
        {allowTransparent && <button type="button" onClick={() => onChange('transparent')} className={`w-6 h-6 rounded border ${value === 'transparent' ? 'border-indigo-500 ring-1 ring-indigo-500' : 'border-slate-200'} bg-slate-100 flex items-center justify-center text-[10px] text-slate-400`} title="Transparent" data-id="element-28">
            /
          </button>}
        <input type="color" value={value === 'transparent' ? '#ffffff' : value} onChange={e => onChange(e.target.value)} className="w-8 h-8 rounded cursor-pointer border-0 p-0" data-id="element-29" />
        <span className="text-xs text-slate-500 font-mono uppercase" data-id="element-30">
          {value}
        </span>
      </div>
    </div>;
}